import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=1b137ec0&"
import script from "./SettingsPage.vue?vue&type=script&lang=ts&"
export * from "./SettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports